// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2sos0","footer":"ModalCreateQualiphyProcedure_footer__3XQPy","additionData":"ModalCreateQualiphyProcedure_additionData__1xdjO"};